import { useApiGet } from "@/hooks/useApi";
import { getPriceInfo } from "../api";

export function usePriceInfo() {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["whoami", "price-info"], // Part of whoami since it can read from the user
		fn: () => getPriceInfo(),
	});

	return { priceInfo: data, isPending, isSuccess, isError, error };
}
